import * as React from 'react';
export const Panel = ({ open, index, title, duration, multiple, children, activeTab, activatePanel }) => {
    const ref = React.useRef(null);
    const [height, setHeight] = React.useState(0);
    const [active, setActive] = React.useState(!!open);
    const isActive = multiple ? active : activeTab === index;
    const style = {
        height: `${isActive ? height : 0}px`
    };
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            const el = ref.current;
            const newHeight = el?.querySelector('.panel__body')?.scrollHeight;
            setHeight(newHeight || height);
        }, duration || 300);
        return () => {
            clearTimeout(timeout);
        };
    });
    return (React.createElement("div", { className: "panel", role: "tabpanel", "aria-expanded": isActive, ref: ref },
        React.createElement("button", { role: "tab", className: "panel__head", onClick: () => {
                multiple ? setActive(!active) : activatePanel(index);
            } }, title),
        React.createElement("div", { style: style, className: "panel__body", "aria-hidden": !isActive },
            React.createElement("div", { className: "panel__content" }, children))));
};
//# sourceMappingURL=panel.js.map